'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// import _typeof from './_typeof'
var hyphenateStyle = function hyphenateStyle(key) {
  return key.replace(/([A-Z])/g, '-$1').toLowerCase();
};
/**
 * Converts ReactJS like style object to
 * proper CSS style.
 *
 * @param {object} style
 * @return {string}
 */

var objToStyle = function objToStyle(style) {
  if (_typeof(style) !== 'object') {
    return '';
  }

  return Object.keys(style).map(function (key) {
    return "".concat(hyphenateStyle(key), ": ").concat(style[key], ";");
  }).join('\n');
};

exports.default = objToStyle;
exports.hyphenateStyle = hyphenateStyle;
